import { render } from "./ConfirmationModal.vue?vue&type=template&id=6881e78f&scoped=true"
import script from "./ConfirmationModal.vue?vue&type=script&lang=js"
export * from "./ConfirmationModal.vue?vue&type=script&lang=js"

import "./ConfirmationModal.vue?vue&type=style&index=0&id=6881e78f&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/rust-webserver/rust-webserver/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6881e78f"]])

export default __exports__